import { performanceMay10Data } from "./performance-may-10";
export const firstChordData = {
  zh: {
    hero: {
      title: "咏歌·初韵",
      subtitle: "咏歌堂首演专场音乐会",
      date: "2026年5月10日 星期日",
      time: "下午 5:00 - 7:00",
      location: "The Arts House Singapore 179429"
    },
    intro: {
      title: "盛演启幕",
      subtitle: "初韵，从心而发",
      paragraphs: [
        "“咏”者，歌永言也；“初”者，始也、新也；“韵”者，音之余也。咏歌堂首次专场演出，以天然之器，发心灵之声。十四曲如十四韵，声声相和，余音袅袅。这里有对希望的礼赞，有对友谊的咏叹，有对夕阳的拥抱，也有牧羊姑娘的悠扬笛声。从中文艺术歌曲到西方经典合唱，从吉卜力的动画旋律到本地创作的温情流露——多元文化的交融，正如合唱团本身：深情于中华文化，亦拥抱世界的精彩。",
        "音乐是桥梁，亦是传承。今晚，咏歌堂邀您共赴这场“初韵”之约。让歌声成为此刻的见证，让和声成为心灵的共鸣。",
        "初韵之后，余韵不绝！"
      ]
    },
    legacy: {
      title: "堂誉溯源",
      subtitle: "咏歌堂简介",
      paragraphs: [
        "咏歌堂成立于2025年，是一支由深爱音乐、坚信其撼动心灵之力的歌者组成的年轻合唱团体。他们以人声为最天然的乐器，以丰富交织的和声，叩动听者的心弦。团员们怀揣对多元文化的敬仰，拥抱世界的精彩，坚信音乐是连接不同文明的桥梁，亦是传承文化的悠远回响。",
        "团中汇聚青年、中年与长者——青春活力、沉稳从容、岁月静好——每一位都将独特的人生经历汇入集体的歌声。是音乐让他们相聚相知，以咏唱表达生活本质与人性温度。他们以和声凝聚圆满，传递真善美，让歌声在最后一个音符落下后，依然久久回荡。"
      ],
      visionTitle: "咏歌堂成立初心",
      visionParagraphs: [
        "这是一群热爱音乐之人，坚信声音不仅是听觉的享受，更是心灵的共鸣。身体是最天然的乐器，不同声部的交响，可以幻化出动人的和声。",
        "这是一群热爱文化之人，崇尚多元。他们深情于中华文化，也拥抱世界的精彩，坚信音乐是最动人的文化桥梁与传承之径。",
        "这是一群热爱生活之人，音乐是他们表达生活的方式，赋予每一天美好旋律。",
        "他们中有青年，中年，长者。青春活力，稳重从容，岁月静好。是音乐让他们走到一起，欢聚一堂！",
        "他们用音乐表达心声，传递真善美！",
        "歌咏，咏歌！咏歌堂！"
      ]
    },
    conductors: {
      title: "匠心领航",
      list: [
        {
          name: "桂乃舜",
          role: "艺术总监兼首席指挥",
          desc: "桂乃舜是新加坡卓越的合唱指挥家之一，享誉国际。毕业于英国伦敦皇家音乐学院，获伦敦音乐学院院士，并于2013年荣获皇家音乐学院院士衔。他曾带领新加坡合唱团在国际赛事中斩获逾250面金奖与冠军。2018年，他率领新加坡国立大学合唱团荣获英国兰戈伦国际音乐节“世界合唱团大奖—帕瓦罗蒂奖杯”，创下新加坡历史。他多次荣获国际“最佳指挥奖”，并活跃于国际舞台，担任比赛评委与音乐节艺术总监，包括新加坡合唱节、歌之旅及亚洲欢唱。现为新加坡音乐家协会创会主席及副主席，曾任国家艺术理事会合唱顾问与评估官，长期致力于合唱人才培养，对新加坡合唱发展影响深远。",
          img: "/images/kwei.jpeg"
        },
        {
          name: "冯克伦",
          role: "指挥",
          desc: "冯克伦拥有圣约瑟大学合唱指挥硕士学位（优等生）及伦敦音乐学院合唱指挥研究员文凭，是新加坡少数在小学、中学及初级学院组别中均荣获新加坡青年节“荣誉金奖”的指挥。自2013年以来，其团队持续在新加坡青年节取得优异成绩。他带领合唱团在国际赛事中屡获金奖、冠军及总冠军，并三度荣获“最佳指挥奖”，亦常受邀担任评委及指挥导师。曾任首届新加坡合唱节艺术总监，参与SG50庆典演出，并为新加坡华乐团及陈洁仪音乐会担任合唱指挥。现执掌多所顶尖学府合唱团，积极培育本地合唱人才。",
          img: "/images/foong.jpeg"
        }
      ]
    },
    talents: {
      title: "群贤荟萃",
      sections: [
        {
          part: "女高音",
          names: "朱亮亮、孙宇婷、曹蕴、徐雯、张文昕、马平、赵予佳",
          imagePrefix: "soprano"
        },
        {
          part: "女中音",
          names: "赵群英、仇苏斐、李冀、王高峡、苟倩、钱能、沈光焱、阮阳",
          imagePrefix: "alto"
        },
        {
          part: "男高音",
          names: "周少华、许惠民、于仡昂、吴呈舫、徐秀峰、杨丰",
          imagePrefix: "tenor"
        },
        {
          part: "男低音",
          names: "于皓南、吴疑、任立群、徐肖华、宋博宁、葛东辉",
          imagePrefix: "bass"
        }
      ]
    },
    program: {
      title: "乐章编序",
      buttonText: "探索详细节目单与歌词",
      intermission: "中场休息 15 分钟",
      parts: performanceMay10Data.zh.parts
    },
    gratitude: {
      title: "礼赞同心",
      subtitle: "衷心感谢每一位为咏歌堂“咏歌·初韵”首演专场音乐会付出努力、给予支持的朋友与机构。是你们的慷慨、信任与热爱，让这第一声和弦得以奏响，让咏歌堂的梦想照进现实。",
      acknowledgements: {
        title: "鸣谢",
        venue: { role: "场地", name: "The ARTS HOUSE" },
        photography: { role: "合唱团摄影", name: "杏仁核照相馆\nEmora Snap" },
        concertPhotography: { role: "音乐会摄影", name: "优铭影视 Ricky Lin\nUMAGIC STUDIO PTE LTD" },
        platinum: { role: "白金赞助", names: ["曹蕴", "许惠民", "徐雯"] },
        gold: { role: "黄金赞助", names: ["葛东辉"] }
      },
      exco: {
        title: "执行委员会",
        members: [
          { role: "艺术总监兼首席指挥", name: "桂乃舜" },
          { role: "指挥", name: "冯克伦" },
          { role: "钢琴", name: "林育珠" },
          { role: "男声团长兼总统筹", name: "徐肖华" },
          { role: "女声团长兼女低声部长", name: "苟倩" },
          { role: "女高声部长", name: "张文昕" },
          { role: "男高声部长", name: "吴呈舫" },
          { role: "男低声部长", name: "宋博宁" }
        ],
        teams: [
          { name: "赞助 / 票务组", members: "张文昕, 吴呈舫" },
          { name: "接待组", members: "苟倩, 徐雯" },
          { name: "财务组", members: "钱能" },
          { name: "后台组", members: "杨丰" },
          { name: "服装统筹", members: "苟倩" },
          { name: "宣传组", members: "宋博宁, 吴呈舫" }
        ]
      },
      founderNoteTitle: "赞助商寄语",
      founderNote: "在领导建益私人有限公司（QXY Resources Pte Ltd）多年城市更新与美化项目之后，我迎来了人生的新篇章——不再是钢筋水泥的构建，而是色彩、声音与故事的交织。艺惠知音是我个人创立的文化平台，源于我对艺术的热爱与执着。在半退休的阶段，我希望通过这个空间，连接热爱创作与美的人们。无论是绘画、戏剧、音乐、文学或雕塑，我相信艺术能点亮人心，凝聚人群。这不仅是一个文化机构，更是一个充满温度的社群。欢迎您与我一同欣赏艺术的多样之美，分享创作的喜悦。",
      founderName: "——许惠民，艺惠知音创始人"
    }
  },
  en: {
    hero: {
      title: "First Chord",
      subtitle: "Konzert Singers Inaugural Concert 2026",
      date: "Sunday, May 10 2026",
      time: "5:00 - 7:00 PM",
      location: "The Arts House Singapore 179429"
    },
    intro: {
      title: "Grand Performance",
      subtitle: "First Chord, from the Heart",
      paragraphs: [
        "We are young, middle-aged, and seasoned by years—youthful vitality, graceful composure, the quiet beauty of time well spent. Three generations, brought together by Konzert Singers. Fourteen pieces, brought to life in the month of May. This concert, titled \"First Chord\", marks not only our inaugural performance, but also an exploration of how the human voice can become an echo of the heart.",
        "\"First\" signifies beginning, newness, the freshness of a debut. \"Chord\" captures both the musical blending of voices and the deeper resonance that lingers after the last note fades.",
        "On this inaugural evening, fourteen pieces unfold like fourteen distinct harmonies—each voice interweaving, each note reverberating.",
        "Here, we celebrate hope, sing of friendship, embrace the golden years, and follow the shepherd girl's flute-borne reverie. From Chinese art songs to Western choral classics, from the melodies of Studio Ghibli to the warmth of local compositions—this is a tapestry of cultures, much like our choir: deeply rooted in Chinese heritage, yet embracing the richness of the world.",
        "After the First Chord, the echoes remain."
      ]
    },
    legacy: {
      title: "The Legacy of Konzert Singers",
      subtitle: "About Konzert Singers",
      paragraphs: [
        "Founded in 2025, Konzert Singers is a young choir united by a deep love for music and its power to move the soul. We see the human voice as the most natural instrument, shaping rich harmonies that resonate with the heart. We embrace a multicultural world, honouring diverse traditions while believing music bridges civilisations and carries cultural memory.",
        "Our members span generations—the young, the mid-life, and the seasoned—blending vitality, composure, and the grace of experience. Each voice brings a unique story into a shared sound. Through song, we express the essence of life and the warmth of the human spirit. We believe the voice is more than sound—it is resonance. In harmony, we share truth, kindness, and beauty, letting our music linger beyond the final note."
      ],
      visionTitle: "Founding Vision",
      visionParagraphs: [
        "We believe music is not only heard, but deeply felt. The human body is our most natural instrument, and harmony creates something greater than the individual.",
        "Rooted in our love for Chinese culture while embracing the world, we see music as a bridge between cultures and a living path of heritage.",
        "We love life, and music is how we express it—bringing meaning to each day.",
        "Across generations, music brings us together. In harmony, we share our voices and convey truth, beauty, and goodness.",
        "We sing—and our songs endure."
      ]
    },
    conductors: {
      title: "Artistic Excellence",
      list: [
        {
          name: "Nelson Kwei",
          role: "Artistic Director and Principal Conductor",
          desc: "Nelson Kwei is one of Singapore's leading choral conductors, internationally recognised for his contributions to choral music. He holds a Fellowship from the London College of Music and an Associateship from the Royal Academy of Music (2013). He has led Singaporean choirs to over 250 gold medals and championship titles at major international competitions. In 2018, he conducted the National University of Singapore Choir to win the prestigious Choir of the World Award – Pavarotti Trophy at the Llangollen International Musical Eisteddfod, a historic first for Singapore. A frequent recipient of Best Conductor awards, he is active internationally as an adjudicator and Artistic Director of major festivals, including the Singapore Choral Festival, A Voyage of Songs, and Asia Cantate. He is the Founding Chairman and Vice President of the Musicians Society of Singapore, and has served as a choral advisor and music assessor with the National Arts Council. He continues to play a key role in nurturing Singapore's choral talent.",
          img: "/images/kwei.jpeg"
        },
        {
          name: "Foong Hak Luen",
          role: "Conductor",
          desc: "Foong Hak Luen holds a Master's degree in Choral Conducting (Magna Cum Laude) from the University of Saint Joseph and a Fellowship from the London College of Music. He is among the few conductors in Singapore whose choirs have achieved Gold with Honours across all divisions of the Singapore Youth Festival. His choirs have won numerous Gold awards, championships, and Grand Prizes at international competitions, and he has received the Outstanding Conductor Award on multiple occasions. He is also regularly invited as an adjudicator and clinician. He was Festival Director of the inaugural Singapore Choral Festival (SG50) and has served as Chorus Master for productions with the Singapore Chinese Orchestra and Kit Chan. He currently conducts leading school choirs and is active in nurturing young choral talent in Singapore.",
          img: "/images/foong.jpeg"
        }
      ]
    },
    talents: {
      title: "Assembly of Talents",
      sections: [
        {
          part: "Soprano",
          names: "Choo Lian Liang, Miu Sun, Vivian Cao, Xu Wen, Zhang Wenxin, Rollar Ma, Ellin Zhao",
          imagePrefix: "soprano"
        },
        {
          part: "Alto",
          names: "Zhao Qunying, Sophia Qiu, Monica Li, Angela Wang Gaoxia, Grace Gou, Qian Neng, Camellia Shen, Ruan Yang",
          imagePrefix: "alto"
        },
        {
          part: "Tenor",
          names: "Zhou Shaohua, Patrick Koh, Yu Yi Ang, Wesley Wu, Xu Xiufeng, Fred Yang",
          imagePrefix: "tenor"
        },
        {
          part: "Bass",
          names: "Leonard Yu, Alex Wu, Philip Ren, Shawn Xu, Song Boning, Ge Donghui",
          imagePrefix: "bass"
        }
      ]
    },
    program: {
      title: "Program Sequence",
      buttonText: "Explore Full Program & Lyrics",
      intermission: "15 Minutes Intermission",
      parts: performanceMay10Data.en.parts
    },
    gratitude: {
      title: "With Gratitude",
      subtitle: "Our heartfelt gratitude goes to every friend and organisation who has contributed to and supported our inaugural concert, First Chord. It is your generosity, trust, and love that have made this very first chord possible, turning the dream of Konzert Singers into reality.",
      acknowledgements: {
        title: "Acknowledgement",
        venue: { role: "Venue", name: "The ARTS HOUSE" },
        photography: { role: "Choir Group Photography", name: "Emora Snap" },
        concertPhotography: { role: "Concert Photography", name: "Ricky Lin\nUMAGIC STUDIO PTE LTD" },
        platinum: { role: "Platinum Sponsor", names: ["Vivian Cao", "Patrick Koh", "Xu Wen"] },
        gold: { role: "Gold Sponsor", names: ["Ge Donghui"] }
      },
      exco: {
        title: "EXCO",
        members: [
          { role: "Artistic Director and Principal Conductor", name: "Nelson Kwei" },
          { role: "Conductor", name: "Foong Hak Luen" },
          { role: "Piano", name: "Lim Geok Choo" },
          { role: "Male Choir Leader & General Coordinator", name: "Shawn Xu" },
          { role: "Female Choir Leader & Alto Section Leader", name: "Grace Gou" },
          { role: "Soprano Section Leader", name: "Zhang Wenxin" },
          { role: "Tenor Section Leader", name: "Wesley Wu" },
          { role: "Bass Section Leader", name: "Song Boning" }
        ],
        teams: [
          { name: "Sponsorship & Ticketing Team", members: "Zhang Wenxin, Wesley Wu" },
          { name: "Hospitality Team", members: "Grace Gou, Xu Wen" },
          { name: "Finance Team", members: "Qian Neng" },
          { name: "Backstage Team", members: "Fred Yang" },
          { name: "Costume Coordinator", members: "Grace Gou" },
          { name: "Publicity Team", members: "Song Boning, Wesley Wu" }
        ]
      },
      founderNoteTitle: "Sponsor's Note",
      founderNote: "After decades of leading QXY Resources Pte Ltd in urban renewal and beautification projects, I've entered a new chapter—one shaped not by concrete and steel, but by color, sound, and story. Arts Connection is my personal venture, born from a lifelong passion for the arts. In semi-retirement, I've created this space to connect with fellow lovers of creativity and beauty. Whether through painting, drama, music, literature, or sculpture, I believe art has the power to illuminate the human spirit and bring people together. This is not just a cultural institution—it's a heartfelt community. I welcome you to join me in celebrating the richness of artistic expression and the joy of sharing it.",
      founderName: "——Patrick Koh, Founder of Arts Connection"
    }
  }
}
